<section class="contact">
    @if(hideTitle == false) {
        <h2>Contact</h2>
    }
    <div class="row">
        <a [href]="euCompLeagueLinks.discord" target="_blank">
            <img src="images/ecl-discord.png" alt="Discord Account">
        </a>
        <a [href]="euCompLeagueLinks.twitter" target="_blank">
            <img src="images/ecl-twitter.png" alt="Twitter Account">
        </a>
        <a [href]="euCompLeagueLinks.twitch" target="_blank">
            <img src="images/ecl-twitch.png" alt="Twitch Account">
        </a>
        <a [href]="euCompLeagueLinks.site">
          EUCOMPLEAGUE
        </a>
    </div>
</section>
